export default __webpack_public_path__ + "static/media/typescript.9e56eac8.png";